<template>
  <div class="promo-timer" :class="[ size, color, { border: border, 'red': endRed, 'expiring': isExpiring }]">
    <div class="promo-timer__text">
      <SvgIcon class="promo-timer__icon" name="promotions/timer" />
      <UiText
        v-if="!noText"
        :text="c_text"
        font="body-text-small"
      />
    </div>
    <UiText
      v-if="!value"
      class="promo-timer__time"
      font="promo-heading-3"
    >
      <BaseSimpleTimer
        :end-diff="endDiff"
        :end="c_endDate"
        @run-out="$emit('run-out')"
        @onTick="onTick"
      />
    </UiText>

    <UiText
      v-else
      font="promo-heading-3"
      color="typography-title01"
      :text="value"
    />
  </div>
</template>

<script>
import BaseSimpleTimer from '~/components/Base/SimpleTimer'
import { border } from 'postcss-sorting/lib/shorthandData.js'

export default {
  name: 'UiTimer',
  components: {
    BaseSimpleTimer,
  },
  props: {
    size: { type: String, default: 'medium' },
    color: { type: String, default: 'default' },
    text: { type: String },
    value: { type: String },
    timestampEndDate: { type: Number },
    endDate: { type: String },
    endDiff: { type: Number },
    noText: { type: Boolean, default: false },
    border: { type: Boolean, default: false },
    isExpiration: { type: Boolean, default: false },
    expiringTime: { type: Number, default: 3600000 },
  },
  data() {
    return {
      isExpiring: false,
    }
  },
  computed: {
    c_text() {
      return this.text ?? this.$tc('cards.duration')
    },
    c_endDate() {
      if (typeof this.timestampEndDate === 'number') {
        return this.timestampEndDate
      }
      else if (typeof this.endDate === 'string') {
        return Date.parse(this.endDate)
      }
      else {
        return Date.now()
      }
    },
    endRed() {
      if (!border) return
      return (Date.parse(this.c_endDate) - Date.now()) < this.expiringTime
    },
  },
  methods: {
    onTick(event) {
      this.$emit('onTick', event)

      if (this.isExpiration) {
        this.checkExpiring()
      }
    },
    checkExpiring() {
      if (this.isExpiring) return false
      this.isExpiring = (this.c_endDate - Date.now()) < this.expiringTime
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
